<template>
  <div class="content p-1 ms-2 me-2 ms-lg-4 me-lg-4">
    <h6 class="page_text_grey">推播通知</h6>
    <div>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="enable_push_notification" v-model="enable_push_notify"
        @change="update_user()">
        <label class="form-check-label" for="enable_push_notification">啟用推播通知</label>
      </div>
      <button class="btn btn-dark mt-2"  data-bs-toggle="modal" data-bs-target="#push_test_modal"
      :class="{'disabled': !enable_push_notify}">測試推播</button>
      <!-- Modal -->
      <div class="modal fade" id="push_test_modal" tabindex="-1" aria-labelledby="push_test_modalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="push_test_modalLabel">測試推播</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <form  v-on:submit.prevent="post_notify">
                <div class="mb-3">
                  <label class="form-label">標題</label>
                  <input type="input" class="form-control" required v-model="test_push_notify.title">
                </div>
                <div class="mb-3">
                  <label class="form-label">內容</label>
                  <input type="input" class="form-control" required v-model="test_push_notify.body">
                </div>
                <div class="mb-3">
                  <label class="form-label">導向頁面</label>
                  <select class="form-select" aria-label="導向頁面" v-model="test_push_notify.redirect" required>
                    <option value="dashboard" selected>資訊總覽</option>
                    <option value="plant_info">案場資訊</option>
                    <option value="alarm">警報</option>
                    <option value="analysis">分析</option>
                    <option value="user">使用者設定</option>
                  </select>
                </div>
                <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
                <button type="submit" class="btn btn-warning mb-0 ms-2" data-bs-dismiss="modal">傳送</button>
              </div>
              </form>
            
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="enable_push_notify">
      <h6 class="page_text_grey mt-3">裝置一覽</h6>
      <div v-if="device_data.length != 0">
        <div class="col-12 col-lg-12 alarm_table">
          <div class="w-100 row  alarm_table_header pt-2 pb-2 fw-bold m-0 d-none d-lg-flex">
              <div class="col-4 text-center">
                  <label class="fs-6">裝置平台</label>
              </div>
              <div class="col-6 text-center">
                  <label class="fs-6">IP位置</label>
              </div>
              <div class="col-2 text-center">
                  <label class="fs-6">啟用推播</label>
              </div>
            
          </div>

          <div class="w-100 alarm_table_body">
            <div class="row m-0 alarm_table_content mt-2 mt-lg-0" v-for="device_i in device_data" v-bind:key="device_i['token']">
                <div class="col-12 d-lg-none mt-2"></div>
                <div class="col-12 col-lg-4 my-auto">
                    <div class="d-flex d-lg-none">
                        <label class="fs-6 fw-bold">裝置平台：</label>
                        <label class="fs-6">{{device_i['type']}}</label>
                    </div>
                    <label class="fs-6 w-100 text-center d-none d-lg-block">{{device_i['type']}}</label>
                </div>
                <div class="col-12 col-lg-6 my-auto">
                    <div class="d-flex d-lg-none mt-2">
                        <label class="fs-6 fw-bold">IP：</label>
                        <label class="fs-6">{{device_i['ip']}}</label>
                    </div>
                    <label class="fs-6 w-100 text-center d-none d-lg-block">{{device_i['ip']}}</label>
                </div>
                <div class="col-12 col-lg-2 my-auto">
                    <div class="d-flex d-lg-none mt-2 mb-2">
                        <label class="fs-6 fw-bold">啟用推播：</label>
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" v-model="device_i['enable_push_notify']">
                        </div>
                    </div>
                    <div class="w-100 justify-content-center d-none d-lg-flex">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="device_i['enable_push_notify']"
                        @change="update_device(device_i)">
                      </div>
                    </div>

                </div>
            </div>           
          </div>
        </div>
      </div>

      <div class="w-100 d-flex text-center" v-else>
        無資料
      </div> 
    </div>
    
  </div>
</template>

<script>

export default {
  data(){
    return {
      enable_push_notify: false,
      device_data: [],
      test_push_notify: {
        title: '',
        body: '',
        redirect: 'dashboard'
      },
    }
  },
  methods:{
    get_user_setting(){
      let that = this
      this.axios.get('/user_setting').then(function(data){
        //console.log(data.data.data)
        let alldata = data.data.data
        that.enable_push_notify = alldata['setting']['enable_push_notify']
        that.device_data = alldata['device_data']
      })
    },
    update_user_setting(type, data={}){
      let that = this
      this.axios.post('/user_setting', {
        'type': type,
        'data': data
      }).then(function(data){

      })
    },
    update_device(data){
      this.update_user_setting('device', data)
    },
    update_user(data){
      this.update_user_setting('user', {'enable_push_notify': this.enable_push_notify})
    },
    post_notify(e){
      let that = this
      this.axios.post('/test_push_notify',this.test_push_notify).then(function(data){
        alert('測試通知已發送')
      }).catch(function(data){
        alert('發送失敗')
      })
      return false
    }
  },
  mounted(){
    this.get_user_setting()
  },
};
</script>
<style>
    .page_text_grey{
        color:  #495057 !important;
    }
    .alarm_table{
        -webkit-box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
        -moz-box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
        box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
    }
    .alarm_table_header{
        background-color: rgba(255, 193, 7, 0.63);
        /* border: 0.5px solid gray; */
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        /* border-bottom: 1px solid black; */
    }
    .alarm_table_footer{
        background-color: rgb(59, 59, 59);
        /* border: 0.5px solid gray; */
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        /* border-bottom: 1px solid black; */
    }
    .alarm_table_body{
        /* border-left: 0.5px solid gray;
        border-right: 0.5px solid gray;
        border-bottom: 0.5px solid gray; */
    }
    .alarm_table_content{
        background-color: rgba(255, 255, 255);
        border-bottom: 0.5px solid gray;
    }
    .footer_icon{
        color: white !important;
        width: 24px !important;
        height: 24px !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    .footer_icon:hover{
        color: orange !important;
    }
    /* Transition Animation */
    .v-enter-active{
        transition: all 1s;
    }
    .v-enter{
        opacity: 0;
        transform: translateX(var(--table_transition));
    }
    
    
    @media (max-width: 991px) {
        .alarm_table_body .alarm_table_content:nth-child(2n+1){
            background-color: rgb(249, 231, 200);
        }
        .alarm_table_content{
            -webkit-box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
            -moz-box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
            box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
        }
    }
</style>